import React from 'react';
import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';

const PageHero = ({ title, subtitle, children }) => (
  <Box position="relative" overflow="hidden">
    {/* Ambient glow orbs */}
    <Box
      position="absolute"
      top="-20%"
      left="-5%"
      w={{ base: '240px', md: '350px' }}
      h={{ base: '240px', md: '350px' }}
      borderRadius="full"
      bg="rgba(255,152,0,0.07)"
      filter="blur(80px)"
      pointerEvents="none"
    />
    <Box
      position="absolute"
      top="-10%"
      right="-5%"
      w={{ base: '180px', md: '280px' }}
      h={{ base: '180px', md: '280px' }}
      borderRadius="full"
      bg="rgba(160,60,20,0.07)"
      filter="blur(80px)"
      pointerEvents="none"
    />

    <Container maxW="container.xl" position="relative" pt={{ base: 12, md: 16 }} pb={{ base: 8, md: 10 }}>
      <VStack spacing={4} textAlign="center">
        <Heading as="h1" size="2xl" variant="gradient" pb={2}>
          {title}
        </Heading>
        {subtitle && (
          <Text fontSize={{ base: 'lg', md: 'xl' }} color="whiteAlpha.800" maxW="2xl">
            {subtitle}
          </Text>
        )}
        {children}
      </VStack>
    </Container>

    <Box className="glow-divider" />
  </Box>
);

export default PageHero;
